/**
 * Precision Commerce — DealFusion design tokens
 * Ink navy + signal orange; Sora + Source Sans 3
 */
export const brand = {
  name: 'DealFusion',
  primary: '#0B3A5C',
  primaryHover: '#0E4A73',
  primaryMuted: '#1A5270',
  accent: '#E85D04',
  accentHover: '#D45203',
  success: '#0F7B5A',
  warning: '#C47F17',
  error: '#C0392B',
  info: '#1A6B8A',
  surface: '#F4F7FA',
  surfaceElevated: 'rgba(255, 255, 255, 0.96)',
  border: '#D7E0EA',
  borderSubtle: '#E8EEF4',
  text: '#122033',
  textSecondary: '#5B6B7C',
  textMuted: '#8494A7',
  headerBg: '#0B3A5C',
  headerFg: '#F4F7FA',
  radius: 10,
  radiusLg: 12,
  fontDisplay: "'Sora', 'Segoe UI', sans-serif",
  fontBody: "'Source Sans 3', 'Segoe UI', sans-serif",
};

export const theme = {
  token: {
    colorPrimary: brand.primary,
    colorSuccess: brand.success,
    colorWarning: brand.warning,
    colorError: brand.error,
    colorInfo: brand.info,
    colorLink: brand.primary,
    colorBgLayout: brand.surface,
    colorBgContainer: '#FFFFFF',
    colorBgElevated: '#FFFFFF',
    colorBorder: brand.border,
    colorBorderSecondary: brand.borderSubtle,
    borderRadius: brand.radius,
    borderRadiusLG: brand.radiusLg,
    borderRadiusSM: 8,
    borderRadiusOuter: 8,
    fontSize: 15,
    fontSizeHeading1: 34,
    fontSizeHeading2: 26,
    fontSizeHeading3: 22,
    fontSizeHeading4: 18,
    fontSizeHeading5: 16,
    lineHeight: 1.55,
    fontFamily: brand.fontBody,
    fontFamilyCode: "'IBM Plex Mono', ui-monospace, monospace",
    controlHeight: 42,
    controlHeightLG: 48,
    controlHeightSM: 34,
    colorText: brand.text,
    colorTextSecondary: brand.textSecondary,
    colorTextTertiary: brand.textMuted,
    colorTextDisabled: '#A8B5C4',
    colorTextHeading: brand.text,
    boxShadow: '0 1px 2px rgba(18, 32, 51, 0.05), 0 1px 3px rgba(18, 32, 51, 0.04)',
    boxShadowSecondary: '0 6px 20px rgba(11, 58, 92, 0.08), 0 2px 6px rgba(18, 32, 51, 0.04)',
    boxShadowTertiary: '0 12px 32px rgba(11, 58, 92, 0.1), 0 4px 10px rgba(18, 32, 51, 0.05)',
    paddingXS: 8,
    paddingSM: 12,
    padding: 16,
    paddingMD: 20,
    paddingLG: 24,
    marginXS: 8,
    marginSM: 12,
    margin: 16,
    marginMD: 20,
    marginLG: 24,
    motionDurationMid: '0.22s',
    motionEaseInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  },
  components: {
    Card: {
      padding: 20,
      paddingLG: 24,
      borderRadiusLG: brand.radiusLg,
      headerFontSize: 16,
      headerFontWeight: 600,
    },
    Button: {
      controlHeight: 42,
      controlHeightLG: 48,
      borderRadius: 8,
      borderRadiusLG: 10,
      primaryShadow: '0 2px 8px rgba(11, 58, 92, 0.22)',
      fontWeight: 600,
    },
    Input: {
      borderRadius: 8,
      controlHeight: 42,
      activeBorderColor: brand.primary,
      hoverBorderColor: brand.primaryMuted,
    },
    Select: {
      borderRadius: 8,
      controlHeight: 42,
    },
    Layout: {
      headerBg: brand.headerBg,
      headerHeight: 68,
      bodyBg: brand.surface,
      siderBg: '#FFFFFF',
      footerBg: brand.primary,
    },
    Menu: {
      itemBorderRadius: 8,
      itemMarginInline: 4,
      itemHoverBg: 'rgba(255, 255, 255, 0.08)',
      itemSelectedBg: 'rgba(232, 93, 4, 0.18)',
      colorItemText: 'rgba(244, 247, 250, 0.82)',
      colorItemTextHover: '#FFFFFF',
      colorItemTextSelected: '#FFFFFF',
      darkItemBg: 'transparent',
      darkItemSelectedBg: 'rgba(232, 93, 4, 0.22)',
      darkItemHoverBg: 'rgba(255, 255, 255, 0.08)',
      fontSize: 14,
    },
    Table: {
      borderRadius: brand.radiusLg,
      headerBg: '#F0F4F8',
      borderColor: brand.borderSubtle,
    },
    Tag: {
      borderRadiusSM: 6,
    },
    Typography: {
      titleMarginBottom: '0.35em',
      titleMarginTop: '0.8em',
    },
  },
};

export default theme;
